// [RGM] 2026-09-17 (reporte Rafael: "todos los planes en empresa muestra número,
// debe mostrar texto" — también en el filtro de la grilla): etiquetas del plan
// del registro (PlanSiprinia) — EmpresaLibreNumerico2 en la tabla Cuenta.
export const PLANES_EMPRESA: Record<number, string> = {
  0: 'Sin plan', 1: 'Unipersonal', 2: 'Duo', 3: 'Empresa',
}

export const planEmpresaLabel = (valor: unknown): string =>
  PLANES_EMPRESA[Number(valor ?? 0)] ?? '—'
